import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { tokens } from '@companycam/slab';
import {
  CheckboxBlank,
  CheckboxMarked,
} from 'components/shared/DesignSystem/Icons';

// #region styled-components
const StyledLink = styled.a`
  color: #0967d2;
`;

const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: 12px;
`;

const AcceptView = styled.div`
  margin: 32px 0px;
`;

const AgreeText = styled.span`
  font-size: ${tokens.size_text_s}px;
  line-height: 1.25;
  color: ${tokens.color_text_subtle_le};
  font-weight: 400;
`;
// #endregion

const TermsDescription = (
  <FormattedMessage
    id="Onboard.terms.description"
    description="Description for accepting terms of service."
    defaultMessage="I agree to <tou>Terms of Use</tou> and <privacy>Privacy Policy</privacy>."
    values={{
      tou: (words) => (
        <StyledLink
          target="_blank"
          rel="noopener noreferrer"
          href="https://companycam.com/terms"
        >
          {words}
        </StyledLink>
      ),
      privacy: (words) => (
        <StyledLink
          target="_blank"
          rel="noopener noreferrer"
          href="https://companycam.com/privacy-policy"
        >
          {words}
        </StyledLink>
      ),
    }}
  />
);

const AcceptTosCheckbox = ({ checked, onClickCheckbox }) => {
  return (
    <AcceptView>
      <StyledLabel>
        {checked ? (
          <CheckboxMarked
            data-testid="signup__accepted-tos"
            tabIndex="0"
            size={24}
            color="#0967D2"
            onClick={onClickCheckbox}
            onKeyDown={(e) => e.keyCode === 13 && onClickCheckbox()}
          />
        ) : (
          <CheckboxBlank
            data-testid="signup__accepted-tos"
            tabIndex="0"
            size={24}
            color="#A9ADB1"
            onClick={onClickCheckbox}
            onKeyDown={(e) => e.keyCode === 13 && onClickCheckbox()}
          />
        )}
        <AgreeText>{TermsDescription}</AgreeText>
      </StyledLabel>
    </AcceptView>
  );
};

export default AcceptTosCheckbox;

AcceptTosCheckbox.propTypes = {
  checked: PropTypes.bool,
  onClickCheckbox: PropTypes.func,
};
